import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'SocialMediaService'
const host = servicesConfig.SocialMediaService as string
const opts: CustomAxiosHeaders = { host, serviceName, useNewToken: true }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const SocialMediaService = {
  allowedLocations: (id: string, fetchAll?: boolean) => 
    request().get(`/${id}/accounts${fetchAll ? '?fetchAll=true' : ''}`)
      .then(responseBody)
      .then(response => ({ ...response.results })),
      
  getGlobalSettings: (locationID: string) => 
    request().get(`/global-settings?locationId=${locationID}`)
      .then(responseBody)
      .then(response => ({ ...response.results }))
}

export default SocialMediaService